<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.p1" />
  </ng-container>

  <ng-container body>
    <email-button [href]="data.recovery_url" [label]="data.recovery_url_label" theme="primary" />
    <email-margin [height]="28" />
    <email-text [contents]="data.p2" presetName="paragraph" />
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text
      [contents]="data.p3_html"
      presetName="paragraph"
      size="small"
      className="web-rt-contains-link"
    />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
